import { render, staticRenderFns } from "./PeriodSelect.vue?vue&type=template&id=32cb96c1&"
import script from "./PeriodSelect.vue?vue&type=script&lang=js&"
export * from "./PeriodSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports